<template>
    <div class="footer-div mt-3 bg-default-color font-base-color">
        <footer class="pl-3 pr-3 container-fluid" >
            <p>ระบบกรอกข้อมูลชันสูตรพลิกศพ</p>
        </footer>
    </div>
</template>

<script>
    export default {
        name: "Footer"
    }
</script>

<style scoped>
    .footer-div{
        padding-bottom: 15px;
        padding-top: 25px;
        font-size: 16px;
        line-height: 10px;
        vertical-align: bottom;
        width: 100%;
        align-content: center;
        text-align: left;
    }
</style>
